import { useEffect } from 'react';
import { movies } from '@/mocks/movies';
import { newsList } from '@/mocks/news';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import LatestNews from '@/pages/home/components/LatestNews';
import PopularMovies from '@/pages/home/components/PopularMovies';
import GenreGrid from '@/pages/home/components/GenreGrid';
import SiteIntro from '@/pages/home/components/SiteIntro';

const sortedByHeat = [...movies].sort((a, b) => b.heat - a.heat);

export default function Home() {
  useEffect(() => {
    document.title = '草民电影 - 最新电影资讯与精选影片推荐';
    const description = document.querySelector('meta[name="description"]');
    if (description) {
      description.setAttribute(
        'content',
        '草民电影为影视爱好者提供最新电影资讯、热门影片推荐及详细电影介绍，涵盖海量电影资源，满足用户多样观影需求。',
      );
    }
  }, []);

  return (
    <div className="w-full">
      <HeroCarousel items={sortedByHeat.slice(0, 5)} />
      <LatestNews items={newsList.slice(0, 5)} />
      <PopularMovies items={sortedByHeat.slice(0, 8)} />
      <GenreGrid />
      <SiteIntro />
    </div>
  );
}